var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongFenxiang(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.525L5.78 7.082M6 9l4.226 2.482M4.367 9.733a1.7 1.7 0 100-3.4 1.7 1.7 0 000 3.4zM11.7 5.4a1.7 1.7 0 100-3.4 1.7 1.7 0 000 3.4zm0 5.267a1.7 1.7 0 110 3.4 1.7 1.7 0 010-3.4z",
    stroke: "#3F465C",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_fenxiang.ff954e1f.svg";
export { SvgTongyongFenxiang as ReactComponent };